<template>
<div>
    <el-select v-model="tissue" placeholder="Please select tissue" style="width:200px;" @change="handleSearch">
        <el-option v-for="option in tissueOptions" :key="option.value" :label="option.label" :value="option.value"></el-option>
    </el-select>
    <el-table :data="paginationData" style="width:100%;max-height: auto;color:black;" empty-text="Loading data." fit>
        <el-table-column prop="enid" label="En_id"></el-table-column>
        <el-table-column prop="chr" label="Chr" width="80px"></el-table-column>
        <el-table-column prop="start" label="Start" width="110px"></el-table-column>
        <el-table-column prop="end" label="End" width="110px"></el-table-column>
        <el-table-column prop="width" label="width" width="80px"></el-table-column>
        <el-table-column prop="annotation" label="annotation"></el-table-column>
        <el-table-column prop="Species" label="Species" width="80px"></el-table-column>
        <el-table-column prop="Tissue" label="Tissue"></el-table-column>
    </el-table>
    <div class="pagination">
        <el-pagination
        :current-page="currentPageRange"
        :page-size="pageSize"
        :total="tableData.length"
        :page-count="pageCount"
        @current-change="handleCurrentChange"
        :background="true"
        layout="prev, pager, next"
        ></el-pagination>
    </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            url: "http://183.175.59.4/devenhancer/",
            records: [], // 查询结果数据
            currentPage: 1,
            pageSize: 10, // 设置每页显示的条数
            tissue: '', 
            tissueOptions: [],
        };
    },
    computed: {
        tableData() {
            return this.records;
        },
        pageCount() {
            return Math.ceil(this.tableData.length / this.pageSize);
        },
        paginationData() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.tableData.slice(start, end);
        },
        currentPageRange() {
            return Math.max(1, Math.min(this.currentPage, this.pageCount));
        },
    },
    mounted() {
        // 获取所有组织类型
        this.$axios
        .get(this.url + "searchname/")
        .then((response) => {
            const uniqueTissues = [...new Set(response.data.map(item => item.Tissue))];
            this.tissueOptions = uniqueTissues.map(tissue => ({ value: tissue, label: tissue }));
        })
        .catch((error) => {
            console.log(error);
            this.$message.error("Failed to fetch tissue options.");
        });
        this.tissue = 'hESC';
        this.handleSearch();
    },
    methods: {
        handleSearch() {
            const params = {
                Tissue: this.tissue,
            };
            this.$axios
                .get(this.url + "individual" + "/", { params })
                .then((response) => {
                this.records = response.data;
                })
                .catch((error) => {
                console.log(error);
                this.$message.error("Failed to fetch data.");
                });
        },
        handleCurrentChange(page) {
            // 处理分页组件的当前页变化事件
            this.currentPage = page;
        },
        exportCsv() {
            const header = ["En_id", "Chromsome", "Start", "End", "width", "annotation", "Species", "Tissue"]; // 如果换别的数据，注意换表头
            // 如果换别的数据，注意换内容,对应prop
            const data = this.tableData.map((row) => ({
                En_id: row.Coreid,
                Chromsome: row.Chr,
                Start: row.Testart,
                End: row.End,
                annotation: row.annotation,
                width: row.width,
                Species: row.Species,
                Tissue: row.Tissue,
            }));
            const csv = [header.join(","), ...data.map((row) => Object.values(row).join(","))].join("\n");
            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "list.csv"); // 输出文件的名字
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },
};
</script>

<style scoped>
.pagination {
text-align: center;
margin: 20px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/home/Tissuelist.vue